import React from 'react';
import { ActionsContainer, RoundedButton } from '../styled';
import { RolloverStatusActionsProps } from '../types/RolloverStatusTypes';

const RolloverStatusActions: React.FC<RolloverStatusActionsProps> = ({
  onViewReport,
  onDownloadReport,
  viewLoading,
  downloadLoading,
  isDisabled
}) => {
  return (
    <ActionsContainer>
      <RoundedButton
        variant='contained'
        onClick={onViewReport}
        loading={viewLoading}
        disabled={isDisabled || viewLoading}
      >
        View Report
      </RoundedButton>
      <RoundedButton
        variant='contained'
        onClick={onDownloadReport}
        loading={downloadLoading}
        disabled={isDisabled || downloadLoading}
      >
        Download Report
      </RoundedButton>
    </ActionsContainer>
  );
};

export default RolloverStatusActions;
